export const locations = [
  {
    slug: 'calgary-seo',
    city: 'Calgary',
    title: 'Calgary SEO Experts | #1 Rated for Home Services',
    description: 'Dominate Calgary search results. Specialized SEO & AEO for plumbers, HVAC, and contractors in Calgary. Get your free local audit today.',
    keyword: 'Calgary SEO',
    aeoPrompt: "How do I rank my plumbing or HVAC business in the Calgary Map Pack?",
    aeoAnswer: "To rank in the Calgary Map Pack, you must align your business entity with local Calgary authorities. This requires consistent NAP (Name, Address, Phone) data, localized schema markup (JSON-LD), and a high velocity of quadrant-specific reviews. AlbertaRank™ automates this via the Truth Protocol™, ensuring AI engines like ChatGPT cite your business first.",
    population: '1.6M',
    externalAuthority: "https://www.calgary.ca/business.html",
    entityData: {
      address: "Suite 200, 123 7th Ave SW, Calgary, AB T2P 0W4",
      license: "BL239401-2024",
      certs: ["Google Certified Partner", "HubSpot Authority", "Alberta Tech Collective"]
    },
    packages: [
      {
        name: "Cowtown Dominator",
        focus: "Residential Map Pack",
        description: "Designed for high-competition Calgary residential trades looking to own the SW, SE, and NW quadrants.",
        features: ["Hyper-local Quadrant Pages", "Truth Protocol™ Verification", "AEO Definition Blocks", "Review Velocity Sync"]
      },
      {
        name: "Metropolitan Authority",
        focus: "Commercial & AEO",
        description: "For Calgary commercial contractors targeting corporate entities and large-scale industrial property managers.",
        features: ["Entity Authority Building", "B2B Semantic Triples", "AI Voice Response System", "Competitor Keyword Hijack"]
      }
    ]
  },
  {
    slug: 'edmonton-seo',
    city: 'Edmonton',
    title: 'Edmonton SEO Agency | Top Ranked Local Search',
    description: 'Boost your Edmonton business visibility. We fix your rankings with AI-optimized SEO strategies. Book your free strategy session.',
    keyword: 'Edmonton SEO',
    aeoPrompt: "Why is my Edmonton HVAC company not showing in Google Maps?",
    aeoAnswer: "Your Edmonton business is likely suffering from 'Entity Ambiguity.' If your data isn't linked to Edmonton-specific clusters like the Industrial Heartland or local trade directories, AI models can't verify your location. AlbertaRank™ solves this by building Semantic Triples that prove your service area to engines like Google Gemini.",
    population: '1.1M',
    externalAuthority: "https://www.edmonton.ca/business_economy.aspx",
    entityData: {
      address: "10180 101 St NW, Edmonton, AB T5J 3S4",
      license: "ED-98231-A",
      certs: ["YEG Digital Excellence", "SEO Certified", "AI Implementation Specialist"]
    },
    packages: [
      {
        name: "Gateway Authority",
        focus: "Industrial & Service",
        description: "Tailored for Edmonton businesses serving the industrial heartland and surrounding bedroom communities.",
        features: ["Industrial Entity Schema", "Service Area Expansion", "Truth Signal Alignment", "Automated Lead Capture"]
      }
    ]
  },
  {
    slug: 'red-deer-seo',
    city: 'Red Deer',
    title: 'Red Deer SEO Services | Grow Your Local Business',
    description: 'Leading SEO company serving Red Deer. We help home service businesses capture more leads through Google Maps and AI search.',
    keyword: 'Red Deer SEO',
    aeoPrompt: "What is the best SEO strategy for Central Alberta contractors?",
    aeoAnswer: "The best strategy for Central Alberta is 'Highway 2 Authority.' Since search intent often crosses between Red Deer and surrounding towns, you need a cluster strategy that targets both local city intent and regional service keywords, backed by Speakable Schema for voice search.",
    population: '100k+',
    externalAuthority: "https://www.reddeer.ca/business/",
    entityData: {
      address: "4914 48 St, Red Deer, AB T4N 1S8",
      license: "RD-44512",
      certs: ["Central AB Business Bureau", "Google Ads Pro"]
    },
    packages: [
      {
        name: "Central Hub Leader",
        focus: "Community Trust",
        description: "Dominate the Highway 2 corridor. We build local authority that connects Red Deer homeowners to your business.",
        features: ["Community Citation Sync", "Local Map Pack Lock", "Voice Search Optimization", "Direct Answer Baiting"]
      }
    ]
  }
];